import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import colorWheel from '../../Theme/ColorWheel';

const styles = StyleSheet.create(
    {
        tab: { marginTop: 30, marginLeft: 10, marginRight: 10, width: "100%" },
        title: { fontSize: 12, borderBottom: '1 solid #747679', width: '95%', fontFamily: "RobotoRegular", color: '#373534' },
        row: { marginTop: 5, marginLeft: 30, fontSize: 10, fontFamily: "RobotoRegular", display: "flex", flexDirection: "row" },
        section: { marginTop: 10, marginLeft: 20 },
        label: { width: "40%", textAlign: "right", marginRight: 10, color: colorWheel.graniteGrey },
        value: { width: "45%" },
    }
)

const requestTypes = {
    1: "Copay",
    2: "PAP",
    20: "BI"
};

const MorphoSysRequestType = props => {
    const { categories } = props;
    const text = categories.map(c => requestTypes[c]).join(" / ");

    return <View style={styles.tab}>
        <Text style={styles.title}>Referral Type</Text>
        <View style={styles.section} wrap={false}>
            <View style={styles.row}>
                <Text style={styles.label}>Request Type</Text>
                <Text style={styles.value}>{text}</Text>
            </View>
        </View>
    </View>


}

export default MorphoSysRequestType;
